module.exports = __webpack_public_path__ + "img/744.5ccb5ea1.jpg";